export default {
  manufacturerDevices: [],
  connectedDevices: [],
  loading: false,
  error: null
}



// WEBPACK FOOTER //
// ./src/store/modules/connecteddevices/state.js